export default __webpack_public_path__ + "static/media/everification.7a127f6d.svg";